window.tarteaucitron && (window.tarteaucitron.services.rdlv_googlemaps = {
    "key": "rdlv_googlemaps",
    "type": "api",
    "name": "Google Maps",
    "uri": "https://adssettings.google.com/",
    "needConsent": true,
    "cookies": [],
    "test": false,
    "js": function () {
        "use strict";
        window.tarteaucitron.fallback(['google-map'], function (node) {
            var html = node.getAttribute('data-html');
            node.removeAttribute('data-html');
            return html ? html : node.innerHTML;
        });
        window.tarteaucitron.user.google_maps_scripts.forEach(function (url) {
            window.tarteaucitron.addScript(url);
        });
    },
    "fallback": function () {
        "use strict";
        var id = 'rdlv_googlemaps';
        window.tarteaucitron.fallback(['google-map'], function (node) {
            node.setAttribute('data-html', node.innerHTML);
            return window.tarteaucitron.engage(id);
        });
    }
});
